<script>
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  render() {
    return (
      <div id="app">
        <router-view />
        <footer class="footer hidden">
          <div class="footer-main">
            <div>
              <span class="footer-main-name">上海新榜信息技术股份有限公司</span>
              <span>复旦大学新闻学院提供全方位学术支持</span>
            </div>
            <div>©2018 NEWRANK 沪ICP备14042332号-2</div>
          </div>
        </footer>
      </div>
    )
  }
}
</script>

<style lang="postcss">
  #app {
    height: 100%;
  }
  .footer {
    background-color: #3c3c3c;
    height: 37px;
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 1000;
    &-main {
      color: #e9e9e9;
      font-size: 14px;
      width: 1210px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      &-name {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue